export default "__VITE_ASSET__D1HnJ$zo__"